<ng-container *ngIf="loading">
  <div class="full-screen-mat-spinner">
    <mat-spinner diameter="60" strokeWidth="4"></mat-spinner>
  </div>
</ng-container>
